import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAppAutoFocus]'
})
export class AppAutoFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }
}
